/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { tableHead } from './tableHead';

import { getReferenceDataProviderClaims, getProvider } from '../Store/action';

import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';

import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';

const DisplayBprovider = () => {
  const {
    rebateProgram,
    displayObj: {
      rebateProgramName: getRebateProgram,
      quarter: getQuarter,
      provider: getProviderList,
    },
    referenceData,
  } = useSelector((state) => state?.sharedState?.BProviderClaimReducer);

  const gridRef = React.useRef();
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [referenceDataList, setReferenceDataList] = React.useState({});
  const [bProvider, setbProvider] = React.useState([]);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  // API call reference Data
  React.useEffect(() => {
    dispatch(
      getReferenceDataProviderClaims({
        codeDomainList: ['PROVIDER_ID_TYPE_CD'],
      })
    );
  }, []);

  const rpcShort = getRebateProgram?.rebateProgramCd;

  // TO get the complete name of the rebate program
  const rebateProgramNameValue = `${
    getRebateProgram?.rebateProgramCd || ''
  } - ${getRebateProgram?.shortDescr || ''}`;

  const data = getProviderList?.providerClaims340BVO ?? [];
  const newData = data.map((item) => {
    return {
      ...item,
    };
  });
  useEffect(() => {
    setbProvider(newData);
  }, [getProviderList]);

  // To give the code value to the provider ID Type column
  React.useEffect(() => {
    if (
      getProviderList?.providerClaims340BVO?.length > 0 &&
      referenceData?.PROVIDER_ID_TYPE_CD?.length > 0
    ) {
      const temp = {};
      const refData = referenceData?.PROVIDER_ID_TYPE_CD;
      for (let i = 0; i < refData?.length; i++) {
        temp[refData[i].codeValueID.codeValue] = refData[i].shortDescription;
      }

      const data = getProviderList?.providerClaims340BVO?.map((item) => {
        return {
          ...item,
          providerIdTypeCd: temp[item.providerIdTypeCd],
        };
      });
      setbProvider(data);
    }
  }, [getProviderList, referenceData]);
  let firstInfo = '';
  let thirdInfo = '';

  firstInfo = `Quarter: ${getQuarter}`;
  thirdInfo = rebateProgramNameValue;

  // To update totals when no condition matches from filter
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  // pinned row
  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };

  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : bProvider;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);

    return data ? parseFloat(data.toFixed(2)) : '0.00';
  };

  const sum2 = (property) => {
    const displayedRows = filterApply ? filteredRows : bProvider;
    if (displayedRows != []) {
      if (property === 'checkLogNum') {
        const data = displayedRows.length;
        return `${data} Checks`;
      }
      const data = displayedRows?.reduce((acc, val) => {
        const value = parseFloat(val.totReimbAmt);

        return acc + value;
      }, 0);

      return data ? parseFloat(data.toFixed(2)) : '0.00';
    }
  };
  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i++) {
      result.push({
        isBottomRow: true,
        providerId: 'Total',
        totReimbAmt: sum2('totReimbAmt'),
        numClaims: sum('numClaims'),
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [bProvider, filteredRows, filterApply]);

  return (
    <>
      <div className="tBillPanel custom-check tabs-container">
        <div className="panel tBillPanel-space devider-line pb-0">
          <CustomSeparator
            parent1="State Reports"
            parent2="Display 340B Provider Claims"
          />
          <Spinner load={spinnerLoader} />
          {!fullScreenView && (
            <>
              <div className="row mb-5" />
              <div className="panel custom-fieldset">
                <div className="custom-check">
                  <div className="form-wrapper">
                    <div className="mui-custom-form input-md">
                      <div className="col-10">
                        <TextField
                          id="Rebate_Program"
                          label="Rebate Program"
                          fullWidth
                          placeholder=""
                          inputProps={{ id: 'Rebate_Program' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={rebateProgramNameValue}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="mui-custom-form input-md">
                      <div className="col-10">
                        <TextField
                          id="Quarter"
                          label="Quarter"
                          fullWidth
                          inputProps={{ id: 'Quarter' }}
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={getQuarter}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          <div
            id="testGrid"
            className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold"
          >
            <TableGrid
              ref={gridRef}
              data-testid="onEditingStopped"
              rowSelection="single"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              rowData={bProvider}
              columnDefs={tableHead}
              exportFile
              animateRows
              sideBar={false}
              fileName="340BProviderClaims"
              reportName="340B Provider Claims Report"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onFilterData={onFilterChanged}
              getFilterApply={getFilterApply}
              onCellFocused={onCellFocused}
              info={{ firstInfo, thirdInfo }}
              pinnedBottomRowData={pinnedBottomRowData}
              isScrollOn
              defaultColWidth={200}
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 30) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name && `${name.substring(0, 30)}...`}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DisplayBprovider;
